/* eslint import/no-cycle: 0, no-undef: 0, react/forbid-prop-types: 0 */
import { Component } from 'preact';
import { Link } from 'preact-router';
import { connect } from 'preact-redux';
import { PropTypes } from 'preact-compat';

import style from './style.scss';
import { routes, langRoutes } from '../../app';
import { langPack } from '../../../utils/langPack';
import { langs, appVersion, ENVIRONMENTS } from '../../../utils/consts';

const socialNetworksArr = ['facebook', 'linkedin', 'instagram'/* ,'medium' */];
const socialNetworks = {
  facebook: {
    icon: '/assets/icons/f-19x19.png',
    link: 'https://www.facebook.com/TelmieHQ',
  },
  linkedin: {
    icon: '/assets/icons/in-19x19.png',
    link: 'https://www.linkedin.com/company/telmie',
  },
  instagram: {
    icon: '/assets/icons/inst-20x20.png',
    link: 'https://www.instagram.com/telmiehq/',
  },
  /* medium: {
    icon: '/assets/icons/m-40×28.png',
    link: '',
  }, */
};

class Footer extends Component {
  onIconClick = (e) => {
    const { alt } = e.target;
    if (alt) {
      window.open(socialNetworks[alt].link);
    }
  }

  getAppVersion = () => (
    process.env.PREACT_APP_ENV === ENVIRONMENTS.DEVELOPMENT
      ? appVersion
      : appVersion
        .replace(/-rc.\d+/, '')
        .split('.')
        .slice(0, 3)
        .join('.')
  );

  render({ _currentUrl }) {
    const { locale } = this.props;
    return (
      <footer className={`uk-navbar uk-navbar-container ${style.footer}`}>
        <div>
          <div className={`uk-navbar-left ${style.left}`}>
            <Link href={langRoutes(langs[locale].code, routes.HOME)} className={style.logo}>
              <img src="/assets/logo.png" alt="Telmie App" />
            </Link>
            <div className={style.copyright}>
              &copy;&nbsp;{langPack[locale].FOOTER.COPYRIGHT_TEXT}
              <div>
                Version
                &nbsp;
                {this.getAppVersion()}
              </div>
            </div>
          </div>
          <div className={`uk-navbar-right ${style.right}`}>
            <nav className={style.footerLinks}>
              <ul className="uk-navbar-nav">
                <li>
                  <a href="https://www.telmie.com/">{langPack[locale].FOOTER.HOME}</a>
                </li>
                <li>
                  <a href="https://www.telmie.com/support">
                    {langPack[locale].FOOTER.SUPPORT}
                  </a>
                </li>
                <li>
                  <a href="https://www.telmie.com/terms-of-use">
                    {langPack[locale].FOOTER.TERMS}
                  </a>
                </li>
                <li>
                  <a href="https://www.telmie.com/privacy">
                    {langPack[locale].FOOTER.POLICY}
                  </a>
                </li>
                <li>
                  <a href="https://www.telmie.com/booking-cancellation-policy">
                    {langPack[locale].FOOTER.CANCELLATION}
                  </a>
                </li>
                <li>
                  <a href="https://www.telmie.com/faq">
                    {langPack[locale].FOOTER.FAQ}
                  </a>
                </li>
              </ul>
            </nav>
            <div className={style.socialIcons}>
              {socialNetworksArr.map((el) => (
                <img src={socialNetworks[el].icon} key={el} onClick={(e) => this.onIconClick(e)} alt={el} />
              ))}
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

Footer.propTypes = {
  locale: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  currentUrl: state.url.url,
});

export default connect(
  mapStateToProps,
  {},
)(Footer);



// WEBPACK FOOTER //
// ./components/global/footer/index.js